import axios from "axios";
import { config } from '../config.js'
import { header , headerToken } from './headers'


export const requestQuote = (data) => {
  return axios.post(config.capiURL + 'contactform/requestquote',data,header)
}

export const getInfoSiren = (siren) => {
  return axios.get(config.capiURL + '/siren/'+siren)
}

export const getProfile = () => {
  return axios.get(config.capiURL + "/profile",headerToken)
}
export const updateProfile = (data) => {
  return axios.post(config.capiURL+'/profile/update', data, headerToken)
}
export const login = (data) => {
  return axios.post(config.capiURL + '/login', data, header)
}
export const getAllDevis = () => {
  return axios.get(config.capiURL + '/quotes', headerToken )
}
export const register = (data) => {
  return axios.post(config.capiURL + '/register',data, header )
}
export const resetPassword = (data) => {
  return axios.post(config.capiURL + '/user/reset-password', data, header)
}

export const forgetPassword = (data) => {
  return axios.post(config.capiURL + '/user/forget-password', data, header)
}

export const singleDevis = () => {
  return axios.get(config.capiURL + 'utilisateur/singledevis', headerToken)
}

/* ------------------------------ Capi santé ----------------------------------------*/

export const submitSante = (data) => {
  return axios.post(config.capiURL + '/sante/submit',data, headerToken)
}
/* ------------------------------ Capi Moto ----------------------------------------*/

export const motoGetMotos = (data) => {
  return axios.get(config.capiURL + '/moto/motos' + data)
}
export const submitMoto = (data) => {
  return axios.post(config.capiURL + '/moto/submit',data, headerToken)
}

/* ------------------------------ Capi Auto ----------------------------------------*/

export const AutoGetBrands = () => {
  return axios.get(config.capiURL + '/auto/brands')
}
export const AutoGetCars = (data) => {
    return axios.get(config.capiURL + '/auto/cars' + data)
}
export const submitAuto = (data) => {
  return axios.post(config.capiURL + '/auto/submit',data, headerToken)
}

/* ------------------------------ Capi Habitation ----------------------------------------*/

export const submitHabitation = (data) => {
  return axios.post(config.capiURL + '/habitation/submit',data, headerToken)
}

/* ------------------------------ Capi Cyber ----------------------------------------*/

export const submitCyberTarif = (data) => {
  return axios.post(config.capiURL + '/cyber/submit',data, headerToken)
}
export const reserveCyberTarif = (data) => {
  return axios.post(config.capiURL + '/cyber/reserve',data, headerToken)
}
export const calculerCyberTarif = (data , autorizationCyber) => {
  return axios.post(config.capiURL + '/cyber/calculer',data, {  
    headers: {
      AuthorizationTarif: "Bearer " + autorizationCyber,
      "content-type": "application/json",
    }
  })
}
/* ------------------------------ Capi multirisque ----------------------------------------*/

export const submitMultirisque = (data) => {
  return axios.post(config.capiURL + '/multirisque/submit',data, headerToken)
}

/* ------------------------------ Capi multirisque Descendale --------------------------- */
export const submitDecenale = (data) => {
  return axios.post(config.capiURL + '/decenale/submit',data, headerToken)
}
